export const ADD_TO_RECENT_PODCAST_IDS = 'ADD_TO_RECENT_PODCAST_IDS'
export const REMOVE_FROM_RECENT_PODCAST_IDS = 'REMOVE_FROM_RECENT_PODCAST_IDS'
export const CLEAR_ACTIVE_PODCAST = 'CLEAR_ACTIVE_PODCAST'
export const CLEAR_PODCASTS = 'CLEAR_PODCASTS'
export const FETCHING_CONTENT = 'FETCHING_CONTENT'
export const SET_ACTIVE_PODCAST = 'SET_ACTIVE_PODCAST'
export const SET_ACTIVE_PODCAST_ID = 'SET_ACTIVE_PODCAST_ID'
export const SET_CURRENT_EPISODE = 'SET_CURRENT_EPISODE'
export const SET_CURRENT_PODCAST = 'SET_CURRENT_PODCAST'
export const SET_EPISODE_LIST = 'SET_EPISODE_LIST'
export const SET_FILES = 'SET_FILES'
export const SET_PODCAST_ANALYTICS = 'SET_PODCAST_ANALYTICS'
export const SET_PODCAST_PLANS = 'SET_PODCAST_PLANS'
export const SET_PODCASTS = 'SET_PODCASTS'
export const SET_PODCAST_CREATION_KEYS = 'SET_PODCAST_CREATION_KEYS'
export const SET_PODCAST_LIST = 'SET_PODCAST_LIST'
export const SET_PODCAST_USER_PERMISSIONS = 'SET_PODCAST_USER_PERMISSIONS'
export const SET_RECENT_PODCASTS = 'SET_RECENT_PODCASTS'
export const SET_RECENT_PODCAST_IDS = 'SET_RECENT_PODCAST_IDS'
export const SET_RECAST_COLOR = 'SET_RECAST_COLOR'
export const SET_PODCAST_CADENCE = 'SET_PODCAST_CADENCE'
export const UPDATING_CONTENT = 'UPDATING_CONTENT'
export const SET_PODCAST_COUNT = 'SET_PODCAST_COUNT'
export const SET_OUTRO = 'SET_OUTRO'
export const SET_INTRO = 'SET_INTRO'
export const SET_VERIFICATION_CODES = 'SET_VERIFICATION_CODES'
export const CLEAR_SEARCH_KEYWORDS = 'CLEAR_SEARCH_KEYWORDS'
export const SET_SEARCH_KEYWORDS = 'SET_SEARCH_KEYWORDS'
